let nextValue = 0;

type EnumeratedObject = { [key: string]: any };

export default function enumerate(keys: Array<string>): EnumeratedObject {
  const obj: EnumeratedObject = {};

  keys.forEach(key => {
    obj[key] = nextValue;
    nextValue++;
  });

  Object.freeze(obj);
  return obj;
}
